import React, { useEffect } from "react";
import styles from "./Home.module.sass";
import Overview from "./Overview";
import PopularProducts from "../../components/PopularProducts";
import ProductViews from "./ProductViews";
import { useHistory } from "react-router";
import { useUser } from "../../context";
import RedeemRequests from "../../components/RedeemRequests";
import Balance from "./Balance";

const Home = () => {
	const history = useHistory();
	const {
		brand,
		tokens: { group },
	} = useUser();

	useEffect(() => {
		if (group === "admin" && !brand) {
			history.push("/explore-brands");
		}
	}, []);
	return group === "admin" && !brand ? (
		""
	) : (
		<>
			<div className={styles.row}>
				<div className={styles.col}>
					<Overview className={styles.card} />
					<ProductViews className={styles.card} />
				</div>
				<div className={styles.col}>
					<RedeemRequests className={styles.card} />
					{/* <Balance className={styles.card} /> */}
					<PopularProducts className={styles.card} views="4" />
				</div>
			</div>
		</>
	);
};

export default Home;
